export const DefaultBoxNodeDisplay = {
  drawingType: 'BOX' as DiagramDrawingType,
  height: 100,
  width: 100,
  x: 145,
  y: 125,
};
